// import React, { useState, useEffect } from 'react';

// const Button = ({ children, onClick, className = '' }) => {
//   return (
//     <button
//       onClick={onClick}
//       className={`px-4 py-2 rounded font-medium transition-all duration-200 hover:opacity-90 ${className}`}
//     >
//       {children}
//     </button>
//   );
// };

// const Card = ({ children, className = '' }) => {
//   return (
//     <div className={`bg-white shadow rounded-lg ${className}`}>
//       {children}
//     </div>
//   );
// };

// const CardContent = ({ children, className = '' }) => {
//   return <div className={`p-4 ${className}`}>{children}</div>;
// };

// const Input = ({ type = 'text', value, onChange, placeholder, name, className = '' }) => {
//   return (
//     <input
//       type={type}
//       value={value}
//       onChange={onChange}
//       placeholder={placeholder}
//       name={name}
//       className={`border border-gray-300 rounded px-3 py-2 w-full ${className}`}
//     />
//   );
// };

// // Utility to generate a random ID
// const generateId = () => '_' + Math.random().toString(36).substr(2, 9);

// const CabinetList = () => {
//   const [orders, setOrders] = useState([]);
//   const [editingId, setEditingId] = useState(null);
//   const [formData, setFormData] = useState({
//     name: '',
//     phone: '',
//     date: '',
//     address: '',
//     totalCost: '',
//     status: 'Pending',
//   });

//   useEffect(() => {
//     let saved = JSON.parse(localStorage.getItem('cabinetOrders')) || [];

//     // Add random ID if missing
//     saved = saved.map(order => ({
//       ...order,
//       id: order.id || generateId(),
//     }));

//     setOrders(saved);
//     localStorage.setItem('cabinetOrders', JSON.stringify(saved));
//   }, []);

//   const deleteOrder = (id) => {
//     const updated = orders.filter(order => order.id !== id);
//     setOrders(updated);
//     localStorage.setItem('cabinetOrders', JSON.stringify(updated));
//   };

//   const submitOrder = (id) => {
//     const updated = orders.map(order =>
//       order.id === id ? { ...order, status: 'Paid' } : order
//     );
//     setOrders(updated);
//     localStorage.setItem('cabinetOrders', JSON.stringify(updated));
//   };

//   const editOrder = (order) => {
//     setEditingId(order.id);
//     setFormData({
//       name: order.name || '',
//       phone: order.phone || '',
//       date: order.date || '',
//       address: order.address || '',
//       totalCost: order.totalCost || '',
//       status: order.status || 'Pending',
//       id: order.id,
//     });
//   };

//   const saveEdit = () => {
//     const updated = orders.map(order =>
//       order.id === editingId ? { ...formData, totalCost: parseFloat(formData.totalCost) } : order
//     );
//     setOrders(updated);
//     localStorage.setItem('cabinetOrders', JSON.stringify(updated));
//     setEditingId(null);
//     setFormData({
//       name: '',
//       phone: '',
//       date: '',
//       address: '',
//       totalCost: '',
//       status: 'Pending',
//     });
//   };

//   const cancelEdit = () => {
//     setEditingId(null);
//     setFormData({
//       name: '',
//       phone: '',
//       date: '',
//       address: '',
//       totalCost: '',
//       status: 'Pending',
//     });
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: name === 'totalCost' ? value.replace(/[^\d.]/g, '') : value,
//     }));
//   };

//   const totalCost = orders.reduce((sum, order) => sum + Number(order.totalCost || 0), 0);

//   return (
//     <div className="p-4 bg-gray-100 min-h-screen">
//       <h2 className="text-2xl font-bold mb-4">Cabinet Orders</h2>
//       <div className="grid grid-cols-2 gap-4 mb-4">
//         <Card>
//           <CardContent>
//             <div className="text-lg">Total Cabinet Orders: {orders.length}</div>
//           </CardContent>
//         </Card>
//         <Card>
//           <CardContent>
//             <div className="text-lg">Total Cost: ₹{totalCost.toFixed(2)}</div>
//           </CardContent>
//         </Card>
//       </div>

//       {orders.map((order) => (
//         <Card key={order.id} className="mb-4 p-4">
//           <CardContent>
//             {editingId === order.id ? (
//               <>
//                 <Input
//                   name="name"
//                   value={formData.name}
//                   onChange={handleInputChange}
//                   placeholder="Customer Name"
//                   className="mb-2"
//                 />
//                 <Input
//                   name="phone"
//                   value={formData.phone}
//                   onChange={handleInputChange}
//                   placeholder="Phone"
//                   className="mb-2"
//                 />
//                 <Input
//                   name="date"
//                   type="date"
//                   value={formData.date}
//                   onChange={handleInputChange}
//                   className="mb-2"
//                 />
//                 <Input
//                   name="address"
//                   value={formData.address}
//                   onChange={handleInputChange}
//                   placeholder="Address"
//                   className="mb-2"
//                 />
//                 <Input
//                   name="totalCost"
//                   type="number"
//                   value={formData.totalCost}
//                   onChange={handleInputChange}
//                   placeholder="Total Cost"
//                   className="mb-2"
//                 />
//                 <div className="flex gap-2 mt-2">
//                   <Button onClick={saveEdit} className="bg-blue-500 text-white">Save</Button>
//                   <Button onClick={cancelEdit} className="bg-gray-500 text-white">Cancel</Button>
//                 </div>
//               </>
//             ) : (
//               <>
//                 <div className="flex justify-between items-center mb-2">
//                   <h3 className="text-lg font-semibold">Customer: {order.name}</h3>
//                   <span
//                     className={`px-2 py-1 text-sm rounded-full ${
//                       order.status === 'Paid'
//                         ? 'bg-green-200 text-green-800'
//                         : order.status === 'Pending'
//                         ? 'bg-yellow-200 text-yellow-800'
//                         : 'bg-red-200 text-red-800'
//                     }`}
//                   >
//                     {order.status}
//                   </span>
//                 </div>
//                 <p>Phone: {order.phone}</p>
//                 <p>Date: {order.date}</p>
//                 <p>Address: {order.address}</p>
//                 <p>Total Cost: ₹{Number(order.totalCost).toFixed(2)}</p>
//                 <div className="flex gap-2 mt-4">
//                   <Button onClick={() => submitOrder(order.id)} className="bg-green-500 text-white">
//                     Submit
//                   </Button>
//                   <Button onClick={() => editOrder(order)} className="bg-blue-500 text-white">
//                     Edit
//                   </Button>
//                   <Button onClick={() => deleteOrder(order.id)} className="bg-red-500 text-white">
//                     Delete
//                   </Button>
//                 </div>
//               </>
//             )}
//           </CardContent>
//         </Card>
//       ))}
//     </div>
//   );
// };

// export default CabinetList;













// src/pages/CabinetList.jsx
//     import React, { useState, useEffect } from 'react';
//     import { saveAs } from 'file-saver';
//     import jsPDF from 'jspdf';
//     import 'jspdf-autotable';

//     const CabinetList = () => {
//     const [orders, setOrders] = useState([]);
//     const [editModalOpen, setEditModalOpen] = useState(false);
//     const [editOrder, setEditOrder] = useState(null);

//     useEffect(() => {
//         const saved = JSON.parse(localStorage.getItem('cabinetOrders')) || [];
//         setOrders(saved);
//     }, []);

//     const deleteOrder = (id) => {
//         const updated = orders.filter((order) => order.id !== id);
//         setOrders(updated);
//         localStorage.setItem('cabinetOrders', JSON.stringify(updated));
//     };

//     const submitOrder = (id) => {
//         const updated = orders.map((order) =>
//         order.id === id ? { ...order, status: 'Paid' } : order
//         );
//         setOrders(updated);
//         localStorage.setItem('cabinetOrders', JSON.stringify(updated));
//     };

//     const totalCost = orders.reduce((sum, order) => sum + order.totalCost, 0);

//     const openEditModal = (order) => {
//         setEditOrder({ ...order });
//         setEditModalOpen(true);
//     };

//     const saveEdit = () => {
//         const updated = orders.map((order) =>
//         order.id === editOrder.id ? editOrder : order
//         );
//         setOrders(updated);
//         localStorage.setItem('cabinetOrders', JSON.stringify(updated));
//         setEditModalOpen(false);
//     };

//     const handleInputChange = (e) => {
//         setEditOrder({ ...editOrder, [e.target.name]: e.target.value });
//     };

//     const exportCSV = () => {
//         const csvRows = [
//         ['ID', 'Name', 'Phone', 'Date', 'Address', 'Cost', 'Status'],
//         ...orders.map((order) => [
//             order.id,
//             order.name,
//             order.phone,
//             order.date,
//             order.address,
//             `$${order.totalCost.toFixed(2)}`,
//             order.status,
//         ]),
//         ];

//         const blob = new Blob([csvRows.map(row => row.join(',')).join('\n')], { type: 'text/csv' });
//         saveAs(blob, 'cabinet-orders.csv');
//     };

//     const exportPDF = () => {
//         const doc = new jsPDF();
//         doc.text('Cabinet Orders', 14, 10);
//         doc.autoTable({
//         head: [['ID', 'Name', 'Phone', 'Date', 'Address', 'Cost', 'Status']],
//         body: orders.map((order) => [
//             order.id,
//             order.name,
//             order.phone,
//             order.date,
//             order.address,
//             `$${order.totalCost.toFixed(2)}`,
//             order.status,
//         ]),
//         });
//         doc.save('cabinet-orders.pdf');
//     };

//     return (
//         <div className="p-4 bg-gray-100 min-h-screen">
//         <h2 className="text-2xl font-bold mb-4">Cabinet Orders</h2>

//         <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
//             <div className="bg-white p-4 shadow rounded">
//             Total Cabinet Orders: {orders.length}
//             </div>
//             <div className="bg-white p-4 shadow rounded">
//             Total Cost: ${totalCost.toFixed(2)}
//             </div>
//         </div>

//         <div className="flex gap-2 mb-4">
//             <button onClick={exportCSV} className="bg-blue-500 text-white px-4 py-2 rounded">
//             Export CSV
//             </button>
//             <button onClick={exportPDF} className="bg-purple-500 text-white px-4 py-2 rounded">
//             Export PDF
//             </button>
//         </div>

//         {orders.map((order) => (
//             <div key={order.id} className="bg-white p-4 mb-4 shadow rounded">
//             <div className="flex justify-between items-center mb-2">
//                 <h3 className="text-lg font-semibold">Customer: {order.name}</h3>
//                 <span className={`px-2 py-1 text-sm rounded-full ${
//                 order.status === 'Paid' ? 'bg-green-200 text-green-800' : 'bg-yellow-200 text-yellow-800'
//                 }`}>
//                 {order.status}
//                 </span>
//             </div>
//             <p>Phone: {order.phone}</p>
//             <p>Date: {order.date}</p>
//             <p>Address: {order.address}</p>
//             <p>Total Cost: ${order.totalCost.toFixed(2)}</p>
//             <div className="flex flex-wrap gap-2 mt-4">
//                 <button
//                 onClick={() => submitOrder(order.id)}
//                 className="bg-green-500 text-white px-3 py-1 rounded"
//                 >
//                 Submit
//                 </button>
//                 <button
//                 onClick={() => deleteOrder(order.id)}
//                 className="bg-red-500 text-white px-3 py-1 rounded"
//                 >
//                 Delete
//                 </button>
//                 <button
//                 onClick={() => openEditModal(order)}
//                 className="bg-yellow-500 text-white px-3 py-1 rounded"
//                 >
//                 Edit
//                 </button>
//             </div>
//             </div>
//         ))}

//         {/* Edit Modal */}
//         {editModalOpen && (
//             <div className="fixed inset-0 bg-black bg-opacity-30 flex justify-center items-center z-50">
//             <div className="bg-white p-6 rounded w-full max-w-lg">
//                 <h3 className="text-xl font-bold mb-4">Edit Order</h3>
//                 <input
//                 type="text"
//                 name="name"
//                 value={editOrder.name}
//                 onChange={handleInputChange}
//                 className="w-full mb-2 p-2 border rounded"
//                 placeholder="Customer Name"
//                 />
//                 <input
//                 type="text"
//                 name="phone"
//                 value={editOrder.phone}
//                 onChange={handleInputChange}
//                 className="w-full mb-2 p-2 border rounded"
//                 placeholder="Phone"
//                 />
//                 <input
//                 type="date"
//                 name="date"
//                 value={editOrder.date}
//                 onChange={handleInputChange}
//                 className="w-full mb-2 p-2 border rounded"
//                 />
//                 <input
//                 type="text"
//                 name="address"
//                 value={editOrder.address}
//                 onChange={handleInputChange}
//                 className="w-full mb-2 p-2 border rounded"
//                 placeholder="Address"
//                 />
//                 <input
//                 type="number"
//                 name="totalCost"
//                 value={editOrder.totalCost}
//                 onChange={handleInputChange}
//                 className="w-full mb-2 p-2 border rounded"
//                 placeholder="Total Cost"
//                 />
//                 <div className="flex justify-end gap-2">
//                 <button
//                     onClick={() => setEditModalOpen(false)}
//                     className="bg-gray-300 px-4 py-2 rounded"
//                 >
//                     Cancel
//                 </button>
//                 <button
//                     onClick={saveEdit}
//                     className="bg-blue-600 text-white px-4 py-2 rounded"
//                 >
//                     Save
//                 </button>
//                 </div>
//             </div>
//             </div>
//         )}
//         </div>
//     );
//     };

// export default CabinetList;


import React from 'react'

const CabinetList = () => {
  return (
    <div>CabinetList</div>
  )
}

export default CabinetList
